export const appSettingsNamespace = 'appSettings';
export const setSelectedEnvironmentType = 'setSelectedEnvironment';
export const setSelectedLanguageType = 'setSelectedLanguage';
export const setSelectedSystemIdType = 'setSelectedSystemId';

export const DEFAULT_APP_LOGIN_URL = '/customercare/login';
export const DEFAULT_SERVER_MIMIC_APP_LOGIN_URL = '/authentication/login';
/**
 * Hardcoded login path used when the tab-scoped React-auth opt-in flag is set.
 * Kept separate from {@link DEFAULT_SERVER_MIMIC_APP_LOGIN_URL} so server-mimic
 * and runtime opt-in stay independently named even though the path matches.
 *
 * TODO(AB#1355453): Remove with the auth-mode opt-in once React auth is the
 * default in every environment.
 */
export const REACT_AUTH_APP_LOGIN_URL = '/authentication/login';
export const APP_LOCAL_DEVELOPMENT_LOGIN_URL = '/auth';

export const LOCAL_ENVIRONMENT_VALUE = 'local';
export const DOMAIN_APP_PREFIX = 'invision';
export const DOMAIN_APP_SUFFIX = 'ascendon.tv';
